export default __webpack_public_path__ + "static/media/paint-bucket.e015e7f7.png";